import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4df9ac7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_video_player = _resolveComponent("vue3-video-player")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_video_player, _mergeProps({ ref: "videoElement" }, _ctx.$attrs, {
      src: _ctx.url,
      onLoadedmetadata: _cache[0] || (_cache[0] = ($event: any) => {_ctx.logData($event); _ctx.$emit('loadedmetadata', $event)}),
      onPause: _ctx.pauseVideo
    }), null, 16, ["src", "onPause"])
  ]))
}